function Error() {
  return (
  <div className="flex flex-1 justify-center items-center text-white text-3xl bg-gradient-to-br from-[#0f2027] via-[#2c5364] to-[#232526] min-h-screen">
      Error 404 - Page Not Found
    </div>
  );
}

export default Error;